import { render, staticRenderFns } from "./GoogleSearchRenderer.vue?vue&type=template&id=554a88eb&scoped=true&"
import script from "./GoogleSearchRenderer.vue?vue&type=script&lang=js&"
export * from "./GoogleSearchRenderer.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSearchRenderer.vue?vue&type=style&index=0&id=554a88eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554a88eb",
  null
  
)

/* custom blocks */
import block0 from "./GoogleSearchRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports